module.exports = __webpack_public_path__ + "static/img/alert.1fa9a35.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alert.gif
// module id = RVdO
// module chunks = 1